import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Plugin } from '../plugin'
import type { State } from '../state'

export const initEntityUsageLookupOnCurrentListLoad = store.reducers.extra(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    new store.reducers.ExtraReducer({
      on: [
        plugin.collection.plugins.currentListPlugin.feature.actions.load
          .success,
      ],
      reduce: (state: State, action) => {
        state = { ...state, entityUsageLookup: { ...state.entityUsageLookup } }
        for (const id of action.data.response.ids) {
          state.entityUsageLookup[id] = {
            deletable: false,
            referencedBy: new Set(),
          }
        }
        return state
      },
    }),
)
